import * as React from 'react'
import {ActiveFiltersView} from '../../../View/Filtering/ActiveFiltersView'
import * as PrismaRequestFilteringState from '../Model/PrismaRequestFilteringState'
import {PrismaRequestFilteringAction} from '../PrismaRequestFilteringActions'
import * as PrismaRequestFilter from '../Model/PrismaRequestFilter'
import * as PrismaRequestFilterType from '../Model/PrismaRequestFilterType'

export function PrismaRequestActiveFiltersView({state, dispatch}: {
    state: PrismaRequestFilteringState.M,
    dispatch: (action: PrismaRequestFilteringAction) => void,
}) {
    return (
        <ActiveFiltersView
            filterLabel={PrismaRequestFilter.label}
            filterToType={PrismaRequestFilter.toFilterType}
            activeFilters={state.activeFilters}
            onDelete={
                (filterType: PrismaRequestFilterType.M) =>
                    dispatch({type: 'RemoveFilter', filterType})
            }
        />
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/PrismaRequestFiltering/View/PrismaRequestActiveFiltersView.tsx